"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-monitor/credit-pull-status.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-monitor%2Fcredit-pull-status.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.creditPullStatusToJSON = exports.creditPullStatusFromJSON = exports.CreditPullStatus = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.creditmonitor.proto';
var CreditPullStatus;
(function (CreditPullStatus) {
    CreditPullStatus["INVALID_CREDIT_PULL_STATUS"] = "INVALID_CREDIT_PULL_STATUS";
    /**
     * SCORE_PRESENT - User was found by the bureau and a score is available.
     */
    CreditPullStatus["SCORE_PRESENT"] = "SCORE_PRESENT";
    /**
     * NO_HIT - User could not be found by the bureau.
     */
    CreditPullStatus["NO_HIT"] = "NO_HIT";
    /**
     * THIN_FILE - User was found by bureau, but was thin file, no score is available.
     */
    CreditPullStatus["THIN_FILE"] = "THIN_FILE";
    /**
     * SAFETY_CHECK_FAILED - The input SSN does not match the SSN on the credit data artifact
     */
    CreditPullStatus["SAFETY_CHECK_FAILED"] = "SAFETY_CHECK_FAILED";
    /**
     * DECEASED - User is deceased.
     */
    CreditPullStatus["DECEASED"] = "DECEASED";
    /**
     * MISC_CONSUMER_ERROR - There was some other issue with the user's data on the bureau side.
     */
    CreditPullStatus["MISC_CONSUMER_ERROR"] = "MISC_CONSUMER_ERROR";
    /**
     * INVALID_PII_FORMAT - User's PII field (name, address, etc) is malformed.
     */
    CreditPullStatus["INVALID_PII_FORMAT"] = "INVALID_PII_FORMAT";
    CreditPullStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(CreditPullStatus || (exports.CreditPullStatus = CreditPullStatus = {}));
function creditPullStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CREDIT_PULL_STATUS':
            return CreditPullStatus.INVALID_CREDIT_PULL_STATUS;
        case 1:
        case 'SCORE_PRESENT':
            return CreditPullStatus.SCORE_PRESENT;
        case 2:
        case 'NO_HIT':
            return CreditPullStatus.NO_HIT;
        case 3:
        case 'THIN_FILE':
            return CreditPullStatus.THIN_FILE;
        case 4:
        case 'SAFETY_CHECK_FAILED':
            return CreditPullStatus.SAFETY_CHECK_FAILED;
        case 5:
        case 'DECEASED':
            return CreditPullStatus.DECEASED;
        case 6:
        case 'MISC_CONSUMER_ERROR':
            return CreditPullStatus.MISC_CONSUMER_ERROR;
        case 7:
        case 'INVALID_PII_FORMAT':
            return CreditPullStatus.INVALID_PII_FORMAT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return CreditPullStatus.UNRECOGNIZED;
    }
}
exports.creditPullStatusFromJSON = creditPullStatusFromJSON;
function creditPullStatusToJSON(object) {
    switch (object) {
        case CreditPullStatus.INVALID_CREDIT_PULL_STATUS:
            return 'INVALID_CREDIT_PULL_STATUS';
        case CreditPullStatus.SCORE_PRESENT:
            return 'SCORE_PRESENT';
        case CreditPullStatus.NO_HIT:
            return 'NO_HIT';
        case CreditPullStatus.THIN_FILE:
            return 'THIN_FILE';
        case CreditPullStatus.SAFETY_CHECK_FAILED:
            return 'SAFETY_CHECK_FAILED';
        case CreditPullStatus.DECEASED:
            return 'DECEASED';
        case CreditPullStatus.MISC_CONSUMER_ERROR:
            return 'MISC_CONSUMER_ERROR';
        case CreditPullStatus.INVALID_PII_FORMAT:
            return 'INVALID_PII_FORMAT';
        case CreditPullStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.creditPullStatusToJSON = creditPullStatusToJSON;
//# sourceMappingURL=credit-pull-status.js.map